import Misc from "../services/misc.service";


const state = {
    name: 'APP Procontra',
    openMobileMenu: false,
    setupLoaded: false,
    // company: {},
    positions: {},
    fileCategory: {},
    availableEmployees: false,
    availableCustomers: false,
    availablePositions: false,
    optionsStatus: [{
        text: "Nie zaczęto",
        value: "not_started"
    },
    {
        text: "W trakcie",
        value: "in_progress"
    },
    {
        text: "Nie opłacono",
        value: "not_payment"
    },
    {
        text: "Ukończono",
        value: "finished"
    },
    {
        text: "Inne",
        value: "other"
    }
    ]
};

const getters = {
    name: state => {
        return state.name;
    },
    mobileMenuActive: state => {
        return state.openMobileMenu;
    },
    setupLoaded: state => {
        return state.setupLoaded;
    },
    // getCompanyName: state => {
    //     return state.company.name
    // },
    // getCompany: state => {
    //     return state.company
    // },
    // getMainBaseCurrency: state => {
    //     return state.company.currency
    // },
    positions: state => {
        return state.positions;
    },
    availableFileCategory: state => {
        return state.fileCategory;
    },
    availableEmployees: state => filter => {
        if (state.availableEmployees === false) return [];
        let r = [];
        if (filter === 'onlyEmployee') {
            state.availableEmployees.forEach(el => {
                if (el.role === 'employee' || el.role === 'admin' || el.role === 'manager') {
                    r.push(el);
                }
            });
            return r;
        }
        if (filter === 'onlyEmployeeActive') {
            state.availableEmployees.forEach(el => {
                if ((el.role === 'employee' || el.role === 'admin' || el.role === 'manager') && el.isActive === true) {
                    r.push(el);
                }
            });
            return r;
        }
        if (filter === 'onlyActive') {
            state.availableEmployees.forEach(el => {
                if (el.isActive === true) {
                    r.push(el);
                }
            });
            return r;
        }
        return state.availableEmployees;
    },
    availableCustomers: state => {
        if (state.availableCustomers === false) return [];
        return state.availableCustomers;
    },
    availablePositions: state => {
        if (state.availablePositions === false) return [];
        return state.availablePositions;
    },
    optionsStatus: state => {
        return state.optionsStatus;
    },
    statusName: state => status => {
        switch (status) {
            case "finished":
                return state.optionsStatus[3].text;
            case "in_progress":
                return state.optionsStatus[1].text;
            case "not_started":
                return state.optionsStatus[0].text;
            case "not_payment":
                return state.optionsStatus[2].text;
            case "other":
                return state.optionsStatus[4].text;
        }
        return "undefined";
    },
    classStatus: () => status => {
        switch (status) {
            case "finished":
                return "success";
            case "in_progress":
                return "primary";
            case "not_started":
                return "warning";
            case "not_payment":
                return "danger";
            case "other":
                return "info";
        }
        return "";
    }
};

const actions = {
    async loadSetup({
        commit
    }, role) {
        // let company = await Misc.loadCompany();
        // commit("setCompanies", company);
        //Load Positions
        if (role !== 'employee_simple') {
            let positions = await Misc.loadPositions();



            commit("setPositions", positions);
            //Load file category
            let fileCategory = await Misc.loadConstructionFilesCategories();
            commit("setFileCategory", fileCategory);
        }
        //
        commit("setupLoaded", true);
        return true;
    },
    async loadAvailableEmployees({
        commit,
        state
    }) {
        if (state.availableEmployees === false) {
            let availableEmployees = await Misc.loadAvailableEmployees();
            commit("setAvailableEmployees", availableEmployees);
        }
        return true;
    },
    async loadAvailableCustomers({
        commit
        // , state
    }) {
        // if (state.availableCustomers === false) {
        let availableCustomers = await Misc.loadAvailableCustomers();
        commit("setAvailableCustomers", availableCustomers);
        // }
        return true;
    },
    async loadAvailablePositions({
        commit
        // , state
    }) {
        // if (state.availablePositions === false) {
        let availablePositions = await Misc.loadAvailablePositions();
        commit("setAvailablePositions", availablePositions);
        // }
        return true;
    },
    // async updateCompany({
    //     commit
    // }, form) {
    //     let company = await Misc.updateCompany(form);
    //     commit("setCompanies", company);
    // }
};

const mutations = {
    toggleMobileMenu(state) {
        state.openMobileMenu = !state.openMobileMenu;
    },
    toggleOffMobileMenu(state) {
        state.openMobileMenu = false;
    },
    setupLoaded(state, payload) {
        state.setupLoaded = payload;
    },
    // setCompanies(state, payload) {
    //     state.company = payload;
    // },
    setPositions(state, payload) {
        state.positions = payload;
    },
    setFileCategory(state, payload) {
        state.fileCategory = payload;
    },
    setAvailableEmployees(state, payload) {
        state.availableEmployees = payload;
    },
    setAvailableCustomers(state, payload) {
        state.availableCustomers = payload;
    },
    setAvailablePositions(state, payload) {
        state.availablePositions = payload;
    },
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};
